import { logDebug, logWarn } from '@ptek/client-logger';
import { getAuthHeaders } from '../config/api';

export async function fetchWithAuth(
  url: RequestInfo | URL,
  options: RequestInit = {}
): Promise<Response> {
  const baseHeaders = {
    ...(await getAuthHeaders()),
    ...(options.headers as Record<string, string>),
  };

  const doFetch = async (headers: Record<string, string>) =>
    fetch(url, { ...options, headers });

  let response = await doFetch(baseHeaders);

  if (response.status === 401 || response.status === 403) {
    const urlString = url.toString();
    const method = options.method || 'GET';

    logWarn(
      'fetchWithAuth',
      `${method} ${urlString} failed with ${response.status} - retrying with refreshed auth`
    );

    const refreshedHeaders = {
      ...(await getAuthHeaders()),
      ...(options.headers as Record<string, string>),
    };

    response = await doFetch(refreshedHeaders);

    if (response.status === 401 || response.status === 403) {
      logWarn(
        'fetchWithAuth',
        `Retry also failed with ${response.status} - auth may be invalid`
      );
    } else {
      logDebug('fetchWithAuth', `Retry succeeded with ${response.status}`);
    }
  }

  return response;
}
